"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExploreEmptyState = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Types_1 = require("Project/ContentSidebar/Types");
var react_1 = __importDefault(require("react"));
var styles = __importStar(require("./ExploreEmptyState.css"));
var getFriendlyName = function (assetType) {
    switch (assetType) {
        case Types_1.AssetType.Video:
            return "videos";
        case Types_1.AssetType.Block:
            return "blocks";
        case Types_1.AssetType.UnsplashImage:
            return "images";
        case Types_1.AssetType.UnsplashCollection:
            return "image collections";
        default:
            return "";
    }
};
var ExploreEmptyState = function (_a) {
    var searchTerm = _a.searchTerm, assetType = _a.assetType;
    return (react_1.default.createElement(kaleidoscope_1.EmptyState, { title: "There's nothing here!", subtitle: !!searchTerm
            ? "No ".concat(getFriendlyName(assetType), " found for \"").concat(searchTerm, "\"")
            : "No ".concat(getFriendlyName(assetType), " found"), className: styles.emptyState }));
};
exports.ExploreEmptyState = ExploreEmptyState;
